import ProviderAPI from "../../src/redux/ProviderAPI";

export const getOtherFeeType = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getOtherFeeType",
    data: data,
    headers: data.token,
  });

  return result;
};

export const postInvoice = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addInvoice",
    data: data,
    headers: data.token,
  });

  return result;
};

export const postOtherFeeType = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addOtherFees",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getInvoice = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getInvoice",
    data: data,
    headers: data.token,
  });

  return result;
};

export const AddPayment = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addPayment",
    data: data,
    headers: data.token,
  });

  return result;
};

export const editPayment = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/editPayment",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getPayment = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getPayment",
    data: data,
    headers: data.token,
  });

  return result;
};

export const sendMail = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/sendEmailInvoice",
    data: data,
    headers: data.token,
  });

  return result;
};

export const AddPaymentBill = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addPaymentBill",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getPaymentType = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getPaymentType",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const AddPaymentType = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addPaymentType",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getPaymentBill = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getPaymentBill",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const deleteInvoice = async (data) => {
  const result = await ProviderAPI({
    type: "DELETE",
    url: "/bills/deleteInvoice",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const getRemarkBooking = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getRemarkBooking",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const AddRemarkBooking = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/addRemarkBooking",
    data: data,
    headers: data.token,
  });

  return result;
};

export const getBillUtility = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/bills/getBillUtility",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const postScheduleInvoice = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/scheduleInvoice",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const editInvoiceUtility = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/editInvoiceUtility",
    data: data,
    // headers: data.token,
  });

  return result;
};

export const editInvoice = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/bills/editInvoice",
    data: data,
    // headers: data.token,
  });

  return result;
};